<template>
    <div>
        <div class="sub_Navi">
            <ul>
                <li><a class="back" href="javascript:window.history.back();">뒤로</a></li>
                <li>
                    <h1>{{ $t('mypage.userInfo') }}</h1>
                </li>
                <li class="linkBox"></li>
            </ul>
        </div>
        <!--//subPage 상단 Navi :End-->
        <!--subPage -->
        <div class="subPage_container">
            <div class="member_wrap">
                <!--회원ID정보-->
                <div class="member_infobox level-fold-wrap">
                    <!-- member level 영역 : 기본 접힘 -->
                    <div class="member_level_panel">
                        <!-- 펼쳤는데 아직 로딩 중일 때만 로딩바 -->
                        <div class="loading_spinner_trade" v-if="!loadStatus">
                            <div class="loading_circle_trade"></div>
                        </div>

                        <!-- 펼쳤고 로딩 완료일 때 이미지 -->
                        <div class="member_level" v-else>
                            <img :src="getImagePath()" />
                        </div>
                    </div>

                    <div class="member_id">
                        <h3>{{ userName }}</h3>
                        <!-- <a class="">{{ $t('mypage.changeUserInfo') }}</a> -->
                    </div>
                </div>
                <!--회원ID정보:End-->
                <!--초대정보 Box-->
                <div class="invite_wrap">
                    <div class="setting--content__title">
                        {{ $t('setting.invite') }}
                    </div>
                    <div class="invite_inner" :class="locale">
                        <div class="invite_box" :class="locale">
                            <h5 class="subtitle">{{ $t('mypage.inviteCode') }}</h5>
                            <p class="code_value">{{ userName }}</p>
                            <input type="hidden" v-model="userName" />
                        </div>
                        <div class="btnBox inv_code">
                            <a class="copy" @click="copyText(userName); popupControll($t('popup.copyInviteCode'))">복사</a>
                            <!-- <a class="sns modal_open" @click="toggleModal('sns')" data-modal="220">공유</a> -->
                        </div>
                    </div>
                    <div class="invite_inner bottom-line" :class="locale">
                        <div class="invite_box" :class="locale">
                            <h5 class="subtitle">{{ $t('mypage.inviteLink') }}</h5>
                            <p class="code_value">{{ inviteLink }}</p>
                            <input type="hidden" v-model="inviteLink" />
                        </div>
                        <div class="btnBox inv_link">
                            <a class="copy" @click="copyText(inviteLink); popupControll($t('popup.copyInviteLink'))">복사</a>
                            <!-- <a class="sns modal_open" @click="toggleModal('sns');" data-modal="220">공유</a> -->
                        </div>
                    </div>
                    <div class="invite_inner qr">
                        <div class="setting--content__title">
                            {{ $t('setting.qr') }}
                        </div>
                        <div class="invite_qr">
                            <img class="qr_frame" src="@/assets/images/setting/qr-wrap.png" alt="frame" />
                            <qrcode-vue 
                                class="qr_code" 
                                :value="inviteLink" 
                                style="width: 50%; height: auto;" 
                                ref="qrCanvas" 
                                tag="canvas">
                            </qrcode-vue>
                        </div>
                        <div class="btnBox inv_qr">
                            <a class="copy" @click="copyText(inviteLink); popupControll($t('popup.copyInviteLink'))">복사</a>
                            <!-- <a class="copy" @click="copyImage(); popupControll($t('popup.copyInviteQR'))">복사 링크</a>
                            <input type="hidden" v-model="inviteLink" /> -->
                        </div>
                    </div>
                </div>
                <!--초대정보 Box:End-->
            </div>

            <!--후원인 설정-->
            <div class="form_wrap">
                <h3 class="title">{{ $t('mypage.setSponsor') }}</h3>
                <input type="text" id="invite_Set" @click="toggleModal('invite_Set')" name="invite_Set"
                    class="form_select w100 modal_open" :value="currentSponsorDescription" placeholder="" readonly
                    data-modal="210">
                <p class="txt_info">
                    {{ $t('mypage.fixSponsorSettings') }}
                </p>
            </div>
            <!--후원인 설정:End-->
            <!-- [모달창]후원인 설정-->
            <div class="modalBackColor" v-show="isModalVisible"></div>
            <Teleport to="#main-view">
                <div class="modal_wrap modal_no210" data-modal="210">
                    <div class="modal_title">{{ $t('mypage.setSponsor') }}<div class="mdcolsebtn"></div>
                    </div>
                    <div class="modal_content">
                        <!--후원인 배치 지정 설정값-->
                        <div class="modal_sponsor_list">
                            <ul>
                                <li :class="{ active: sponsor == 'default' }">
                                    <div class="lt_1">
                                        <h3 class="sponsor_set">{{ $t('mypage.regSponsor') }}</h3>
                                    </div>
                                    <div class="lt_2">
                                        <input type="radio" id="spChk_001" name="spChk" value="default"
                                            @change="updateInviteLink('default')" checked>
                                        <label for="spChk_001"></label>
                                    </div>
                                </li>
                                <li :class="{ active: sponsor == 'left' }">
                                    <div class="lt_1">
                                        <h3 class="sponsor_set">{{ $t('mypage.setLeftGroup') }}</h3>
                                    </div>
                                    <div class="lt_2">
                                        <input type="radio" id="spChk_002" name="spChk" value="left"
                                            @change="updateInviteLink('left')">
                                        <label for="spChk_002"></label>
                                    </div>
                                </li>
                                <li :class="{ active: sponsor == 'right' }">
                                    <div class="lt_1">
                                        <h3 class="sponsor_set">{{ $t('mypage.setRightGroup') }}</h3>
                                    </div>
                                    <div class="lt_2">
                                        <input type="radio" id="spChk_003" name="spChk" value="right"
                                            @change="updateInviteLink('right')">
                                        <label for="spChk_003"></label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </Teleport>
            <!-- sns 공유  -->
            <!-- <div class="modal_pop_small modal_no220" data-modal="220" v-show="isModalVisible">
                <div class="smallPop popup_block">
                    <div class="pop_title">
                        <p>{{ $t('popup.share') }}</p><span class="pop_close">창닫기</span>
                    </div>
                    <div class="con_wrap">
                        <div class="pop_sns_inner">
                            <ul>
                                <li><a href="#none" class="sns_instagram">인스타그램</a></li>
                                <li><a href="#none" class="sns_facebook">페이스북</a></li>
                                <li><a href="#none" class="sns_kakaotalk">카카오톡</a></li>
                                <li><a href="#none" class="sns_twitter">트위터</a></li>
                                <li><a href="#none" class="sns_tiktok">틱톡</a></li>
                                <li><a href="#none" class="sns_telegram">텔레그램</a></li>
                                <li><a href="#none" class="sns_line">라인</a></li>
                                <li><a href="#none" class="sns_wechat">위챗</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { toggleModal } from '@/utils/modalControll';
import { copyText } from '@/utils/copy';
import { popupControll } from '@/utils/modalText';
import api from '@/api/apiAuth'
import apiUser from "@/api/apiUser";
import QrcodeVue from 'qrcode.vue';

export default {
    name: "MemberInfo",
    components: {
        QrcodeVue
    },
    data() {
        return {
            level: null,
            userName: localStorage.getItem("userName"),
            inviteLink: null,
            currentSponsorDescription: this.$t('mypage.regSponsor'),
            loadStatus: false,
            isLevelOpen: false,
            sponsor: 'defalt'
        }
    },
    setup() {
    const { t, locale } = useI18n({ useScope: "global" });
    return {
      t,
      locale,
    };
  },
    async beforeMount() {
        this.getDashboard();
    },
    mounted() {
        this.updateInviteLink('default');
    },
    methods: {
        toggleModal,
        copyText,
        popupControll,
        async getDashboard() {
            try {
                const response = await apiUser.getDashboard();
                this.level = response.data.level
                this.loadStatus = true;
            }
            catch (error) {
                console.error("Error getDashboard:", error);
                // return;
            }
        },
        updateInviteLink(group) {
            this.sponsor = group;
            api[`getLink${group.charAt(0).toUpperCase() + group.slice(1)}`]().then(response => {
                // // console.log('response',  response.isSuccess)
                // // console.log('response',  response.data.inviteUrl)
                if (response.isSuccess) {
                    this.inviteLink = response.data.inviteUrl;
                    // Check and update description based on group
                    switch (group) {
                        case 'default':
                            this.currentSponsorDescription = this.$t('mypage.regSponsor', 'Register Sponsor');
                            break;
                        case 'left':
                            this.currentSponsorDescription = this.$t('mypage.setLeftGroup', 'Set Left Group');
                            break;
                        case 'right':
                            this.currentSponsorDescription = this.$t('mypage.setRightGroup', 'Set Right Group');
                            break;
                    }
                    this.closeModal();
                } else {
                    console.error(`Failed to fetch ${group} link`);
                }
            }).catch(error => {
                console.error(`Error fetching ${group} link:`, error);
            });
        },
        checkInitialRadio(group) {
            document.getElementById(`spChk_${group === 'default' ? '001' : group === 'left' ? '002' : '003'}`).checked = true;
        },
        copyImage() {
            this.$nextTick(() => {
                const canvas = this.$refs.qrCanvas.$el;
                if (canvas) {
                    canvas.toBlob(blob => {
                        const item = new ClipboardItem({ "image/png": blob });
                        navigator.clipboard.write([item]).then(() => {
                        }).catch(e => {
                            console.error('Error copying image: ', e);
                        });
                    });
                } else {
                    console.error('No canvas element found');
                }
            });
        },
        closeModal() {
            let closeBtn = document.querySelector('.modal_no210 .mdcolsebtn') || document.querySelector('.modal_no210 .pop_close');
            if (closeBtn) {
                closeBtn.click();
            }
        },
        getImagePath() {
            if (this.level === null) {
                return
            } else {
                return require("@/assets/images/level/level_" +
                this.level +
                ".png");
            }
        },
    }
}
</script>

<style scoped>
.loading_spinner_trade {
  margin: auto;
  text-align: center;
  padding-left: 15px;
}

.loading_circle_trade {
  margin: 50px auto;
  width: 40px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, var(--primary-color) 94%, #0000) top / 8px 8px no-repeat,
    conic-gradient(#0000 30%, var(--primary-color));
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: load 1.5s linear infinite;
}

.loading_spinner {
  margin: auto;
  text-align: center;
  padding-top: 100px;
}

.loading_circle {
  margin: 0 auto;
  width: 60px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, var(--primary-color) 94%, #0000) top / 8px 8px no-repeat,
    conic-gradient(#0000 30%, var(--primary-color));
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: load 1.5s linear infinite;
}

.level-fold-wrap {
  position: relative;
  overflow: visible;
}

/* member level 접힘/펼침 영역 */

/* 접기/펼치기 버튼 */
.level-toggle-btn {
  position: absolute;
  left: 0;
  top: 50%;
  z-index: 5;

  width: 22px;
  height: 52px;
  padding: 0;
  border: 0;
  border-radius: 0 12px 12px 0;

  background: rgba(255, 255, 255, 0.13);
  backdrop-filter: blur(8px);
  box-shadow:
    0 4px 14px rgba(0, 0, 0, 0.22),
    inset 1px 0 0 rgba(255, 255, 255, 0.15);

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  transform: translate(-2px, -50%);
  transition: all 0.25s ease;
}

.level-toggle-btn:active {
  transform: translate(-2px, -50%) scale(0.96);
}

/* 삼각형 아이콘 */
.level-toggle-btn span {
  width: 0;
  height: 0;

  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-left: 8px solid rgba(255, 255, 255, 0.78);

  transition: transform 0.25s ease;
}

/* 펼쳐졌을 때 화살표 방향 변경 */
.level-toggle-btn.open {
  background: rgba(108, 26, 245, 0.28);
}

.level-toggle-btn.open span {
  transform: rotate(180deg);
}

/* 펼침 애니메이션 */
.level-slide-enter-active,
.level-slide-leave-active {
  transition: all 0.25s ease;
}

.level-slide-enter-from,
.level-slide-leave-to {
  max-width: 0;
  opacity: 0;
  transform: translateX(-8px);
}

.level-slide-enter-to,
.level-slide-leave-from {
  max-width: 120px;
  opacity: 1;
  transform: translateX(0);
}

/* 로딩바는 펼쳤을 때만 들어오니까 크기 과하게 안 잡히게 */
.loading_spinner_trade {
  margin: auto;
  text-align: center;
  padding-left: 15px;
}

.loading_circle_trade {
  margin: 20px auto;
  width: 36px;
}

@keyframes load {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
/* .subPage_container {
} */

.member_wrap {
    display: flex;
    padding: 20px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 32px;
    align-self: stretch;
    border-radius: 10px;
    background: var(--Menu-Dark);
    width: 95%;
    margin: 0 auto;
}

.setting--content__title {
    color: var(--Main, #FFF);

    /* Headline */
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 122.222% */
    text-align: start;
    width: 100%;
    margin-bottom: 16px;
}

.invite_qr {
  position: relative; /* QR 코드를 띄우기 위한 기준점 */
  display: inline-block; /* 바탕 이미지 크기에 맞게 영역 설정 */
  width: 100%; /* 레이아웃에 맞게 크기 조절 */
}

.invite_qr .qr_frame {
  width: 100%; /* 프레임 이미지가 컨테이너에 꽉 차도록 */
  display: block;
}

.invite_qr .qr_code {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 정확한 정중앙 배치 */
  
  /* 기존 인라인 스타일 적용 */
  border: 10px solid white;
  border-radius: 8px;
  width: 60%; /* 프레임 안쪽 여백에 맞게 퍼센트를 살짝 조절해 보세요 */
  height: auto;
}

.form_wrap {
    width: 95%;
    margin:auto;
}
</style>

